import { render, staticRenderFns } from "./teacherFeatured.vue?vue&type=template&id=680917c4&scoped=true&"
import script from "./teacherFeatured.vue?vue&type=script&lang=js&"
export * from "./teacherFeatured.vue?vue&type=script&lang=js&"
import style0 from "./teacherFeatured.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./teacherFeatured.vue?vue&type=style&index=1&id=680917c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680917c4",
  null
  
)

export default component.exports